// Appleman product page: blocks wrapped in <am-live data-am-live="key"> swap their content
// with the freshly rendered version when the customer picks another variant.
if (!customElements.get('am-live')) {
  customElements.define(
    'am-live',
    class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || document;
        this.onUpdate = (event) => {
          const html = event.detail && event.detail.data && event.detail.data.html;
          if (!html) return;
          const fresh = html.querySelector(`am-live[data-am-live="${this.dataset.amLive}"]`);
          if (fresh) this.innerHTML = fresh.innerHTML;
        };
        this.section.addEventListener('variant:update', this.onUpdate);
      }
      disconnectedCallback() {
        this.section && this.section.removeEventListener('variant:update', this.onUpdate);
      }
    }
  );
}
